module.exports = __webpack_public_path__ + "img/small-3.7128a4ca.jpg";